import { ShadowBox } from 'components/ShadowBox'
import { Input } from 'components/atom/Input'
import { useForm, useFieldArray, Controller } from 'react-hook-form'
import React, { useEffect, useRef, useState } from 'react'
import useTranslation from 'hooks/useTranslation'
import usePostList from 'hooks/query/userPostList'
import { Modal } from 'components/layout/Modal'
import { useNavigate } from 'react-router-dom'
import 'App.css'
import useGetBgm from 'hooks/query/useGetBgm'
import useGetTransition from 'hooks/query/useGetTransition'
import useGetVoice from 'hooks/query/useGetVoice'

import { Usage } from 'service/user'
import {
  getLocalStorage,
  LOCAL_THUMBNAIL_INFO,
  removeLocalStorage,
  renderPaybackVideo,
  saveLocalStorage,
  showYoutubeAuth,
  UserType,
} from 'utils/common'

import { CSSTransition } from 'react-transition-group'
import useGetThumbnail from 'hooks/query/useGetThumbnail'

import { GuideToUse } from 'components/GuideToUse'

import { GuideModal } from 'components/freePlan/GuideModal'
import { PromotionCircle } from 'components/upgrade/PromotionCircle'

import { useGetSubtitleLong } from 'hooks/query/useGetSubtitle'
import { longFormCreateBtnClick } from 'utils/metaAd'
import { PlanPromotionBanner } from 'components/affiliate/PlanPromotionBanner'
import { usePostExperiencePlan } from 'hooks/query/usePostExperiencePlan'
import { isMobile } from 'react-device-detect'
import {
  EmptyPlan,
  FreePlan,
  LightPlan,
  ProAndPremiumPlanAnnual,
  ProAndPremiumPlanMonthly,
} from 'components/PlanDashBoard/PlanDashBoard'
import useGetMePlan from 'hooks/query/useGetMePlan'
import classNames from 'classnames'

import { FormValues } from 'utils/type'
import { PlanPriceModal } from 'components/payment/PlanPriceModal'
import useUserStore from 'store/useUserStore'
import useUsageStore from 'store/useUsageStore'
import { FreePlanBanner } from 'components/freePlan/Banner'

import { FailWithShortModal } from 'pages/product-video-editor/components/video/FailWithShortModal'

import { useMutateMyPoint } from 'hooks/query/point/useMutateMyPoint'
import { Spinner } from 'components/atom/Spinner'
import { TransitionModal } from 'pages/product-video-editor/components/video/TransitionModal'
import {
  AIRecommendProductShortTitleType,
  AiThumbnailTitle,
  LinkDetailType,
  OutroFactor,
  ThumbnailType,
  TransitionFactor,
} from 'service/list'

import useGetOutro from 'hooks/query/useGetOutro'
import useGetAIPromptGroup from 'hooks/query/useGetAIPromptGroup'

import useGetVoiceTag from 'hooks/query/useGetVoiceTag'

import useGetSticker from 'hooks/query/useGetSticker'
import useGetStickerLocation from 'hooks/query/useGetStickerLocation'

import { ReactComponent as UlClipBoardIcon } from 'svg/u_clipboard.svg'
import { ReactComponent as StarIcon } from 'svg/star_white.svg'

import { ExtensionListModal } from 'pages/product-video-editor/components/video/ExtensionListModal'

import { ExtensionTooltip } from 'pages/product-video-editor/components/video/ExtensionTooltip'
import { InstallExtensionFloating } from 'components/extension/InstallExtensionFloating'

import YouTube from 'react-youtube'
import useGetIntro from 'hooks/query/useGetIntro'
import useGetThumbnailPlacid from 'hooks/query/useGetThumbnailPlacid'
import useGetAiRecommendClipTitle from 'hooks/query/extension/useGetAiRecommendClipTitle'
import useGetAiRecommendThumbnailTitle from 'hooks/query/extension/useGetAiRecommendThumbnailTitle'
import { FeatureDescription } from 'components/FeatureDescription'
import { AuthGuard } from 'components/gaurd/AuthGuard'
import { FastclickDashBoard } from 'components/fastclick/FastclickDashBoard'
import { ExtensionErrorGuideTooltip } from 'pages/product-video-editor/components/video/ExtensionErrorGuideTooltip'
import { FastclickDescription } from 'components/fastclick/FastclickDescription'
import { ShortFormTooltip } from 'pages/product-video-editor/components/video/ShortFormTooltip'
import { Helmet } from 'react-helmet-async'
import { WithShortFormCreate } from 'pages/product-video-editor/components/video/WithShortFormCreate'
import { ExtensionListFailModal } from 'pages/product-video-editor/components/video/modal/ExtensionListFailModal'
import {
  defaultValues,
  initializeDefaults,
  initSetValue,
  loadProductShortData,
  setPromptGroupDataFromList,
  setVideoDataValueFromList,
  setVideoDataValueFromListNoUsable,
  setVideoDataValueNoUsable,
} from 'utils/videoEditorUtils'
import ProductItemEmpty from './components/product/ProductItemEmpty'
import ProductList from './components/product/ProductList'
import { ScriptInputModeToggle } from './components/ScriptInputModeToggle'
import { ScriptSelector } from './components/product/ScriptSelector'
import { useScriptStore } from 'store/useScriptStore'
import useGetUserVoice from 'hooks/query/useGetUserVoice'
import { FastcutLongformEffectSelector } from './components/effect/FastcutLongformEffectSelector'
import FastcutShortformEffectSelector from './components/effect/FastcutShortformEffectSelector'
import useGetSubtitleColor from 'hooks/query/useGetSubtitleColor'
import { logger } from 'utils/logger'
import useGetAiRecommendClipProductShortTitle from 'hooks/query/extension/useGetAiRecommendProductShortTitle'
import useGetSubtitleFont from 'hooks/query/useGetSubtitleFont'
import useGetSubtitleSize from 'hooks/query/useGetSubtitleSize'
import { MemberTitle } from './components/MemberTitle'
import { NoneMemberTitle } from './components/NoneMemberTitle'
import { TextArea } from './components/TextArea'
import { CreateVideoType } from 'constant/videoTypes'
import {
  createLongFormVideoFormData,
  createShortFormVideoData,
  PRODUCT_NAME_PATTERN,
} from './util'
import { YoutubeTitle } from './components/YoutubeTitle'
import useCreateFastCutProductShort from 'hooks/query/useCreateFastCutProductShort'

export const Video = () => {
  const { t } = useTranslation()
  const urlParams = new URLSearchParams(window.location.search)
  const LINK_PAGE_CNT = 30
  const isTime = urlParams.get('time')

  const video_page_youtube = getLocalStorage('vpy')

  const videoEditorData = getLocalStorage('videoEditorData')
  const productShortData = getLocalStorage('productShortData')

  const { mutate: myPointMutate, mutateAsync: myPointMutateAsync } =
    useMutateMyPoint()
  const { data: bgmList, refetch: bgmRefetch } = useGetBgm()
  const { data: aiPromptGroup, refetch: aiPromptGroupRefetch } =
    useGetAIPromptGroup()
  const { data: transitionList, refetch: transitonRefetch } = useGetTransition()
  const { data: outroList } = useGetOutro()
  const { data: introList } = useGetIntro()
  const { data: voiceList, refetch: voiceRefetch } = useGetVoice()
  const { data: userVoiceList, refetch: userVoiceRefetch } = useGetUserVoice()
  const { data: stickerList } = useGetSticker()
  const { data: stickerLocationList } = useGetStickerLocation()
  const { data: subtitleColorList } = useGetSubtitleColor()
  const { data: subtitleFontList } = useGetSubtitleFont()
  const { data: subtitleSizeList } = useGetSubtitleSize()
  const { data: thumbnailList, refetch: thumbnailRefetch } = useGetThumbnail()
  const { data: thumbnailPlacIdList } = useGetThumbnailPlacid()
  const { data: voiceTags } = useGetVoiceTag()
  const { data: subTitleList } = useGetSubtitleLong()
  const { mutate: experiencePlanMutate } = usePostExperiencePlan()

  const navigate = useNavigate()
  const [isFreePlanModal, SetFreePlanModal] = useState<boolean>(false)

  const userInfo = useUserStore((state: any) => state.userInfo)
  const refetch = useUserStore((state: any) => state.refetch)
  const usageRefetch = useUsageStore((state: any) => state.usageRefetch)
  const { isAIGenerated } = useScriptStore()
  const { data: userPlanInfo, refetch: planRefetch } = useGetMePlan()

  const { mutateAsync, isPending: clipTitleIsPending } =
    useGetAiRecommendClipTitle()
  const { mutateAsync: thumbnailMutateAsync, isPending: thumbnailIsPending } =
    useGetAiRecommendThumbnailTitle()

  const [aiRecommendClipTitle, setAiRecommendClipTitle] = useState<
    string[] | null
  >(null)

  const [aiRecommendThumbnailTitle, setAiRecommendThumbnailTitle] =
    useState<AiThumbnailTitle | null>(null)

  const [isAiName, setAiName] = useState(true)
  const { isPending, mutate } = usePostList()
  const {
    mutate: createFastCutProductShortMutate,
    isPending: createFastCutProductShortIsPending,
  } = useCreateFastCutProductShort()
  const [isGuideModal, setGuideModal] = useState<boolean>(false)
  const [isRequest, setRequest] = useState<boolean>(true)
  const [createVideoType, setCreateVideoType] = useState<CreateVideoType>(
    CreateVideoType.PRODUCT_LONG
  )

  const [saveSuccessModal, setSaveSuccessModal] = useState<boolean>(false)
  const [essentialCheck, setEssentialCheck] = useState<boolean>(false)
  const [isYoutube, setIsYoutube] = useState<boolean>(false)

  const [isTransitionModal, setTransitionModal] = useState<boolean>(false)

  const [selectedLinks, setSelectedLinks] = useState<LinkDetailType[]>([])
  const [error, setError] = useState({
    products: [
      { link: false, product: false },
      { link: false, product: false },
      { link: false, product: false },
    ],
    mainTitle: false,
    thumbnail: false,
  })
  const [selectedTransitionIndex, setSelectedTransitionIndex] =
    useState<number>(0)
  const [copyTransitionList, setCopyTransitionList] = useState<
    TransitionFactor[] | []
  >([])

  const [copyOutroList, setCopyOutroList] = useState<OutroFactor[] | []>([])

  const [isOpen, setIsOpen] = useState(true)

  const [isOpenLinkMethod, setOpenLinkMethod] = useState<boolean>(false)
  const [isOpenExtensionMethod, setOpenExtensionMethod] =
    useState<boolean>(false)
  const [isOpenExtensionListFailModal, setIsOpenExtensionListFailModal] =
    useState<boolean>(false)
  const [errorText, setErrorText] = useState<React.ReactNode>('')
  const [errorTitle, setErrorTitle] = useState<string>('')

  const [shortFormTooltip, setShortFormTooltip] = useState<boolean>(false)
  const [isOpenExtensionTooltip, setOpenExtensionTooltip] =
    useState<boolean>(false)
  const [isOpenExtensionErrorGuideTooltip, setOpenExtensionErrorGuideTooltip] =
    useState<boolean>(false)
  const [usage, setUsage] = useState<Usage>()

  const [mobileStatus, setMobileStatus] = useState<boolean>(false)
  const [isPlanPriceModal, setPlanPriceModal] = useState<boolean>(false)
  const [isFailWithShortModal, setFailWithShortModal] = useState<boolean>(false)
  const [placIdThumbnail, setPlacIdThumbnail] = useState<
    { id: number; path: string }[]
  >([])

  const [selectedPlacIdThumbnail, setSelectedPlacIdThumbnail] = useState<{
    id: number
    path: string
  } | null>(null)
  const [selectedItem, setSelectedItem] = useState<ThumbnailType | null>(null)
  const [isSaveThumbnail, setIsSaveThumbnail] = useState<boolean>(false)

  // inputRef
  const mainTitleInputRef = useRef<null | HTMLInputElement>(null)
  const thumbNailDivRef = useRef<null | HTMLDivElement>(null)
  const subtitleDivRef = useRef<null | HTMLDivElement>(null)
  const transitionDivRef = useRef<null | HTMLDivElement>(null)
  const productsRef = useRef<null | HTMLDivElement>(null)
  const [selectedLinkIds, setSelectedLinkIds] = useState<number[]>([])
  const [linkPageSize, setLinkPageSize] = useState(LINK_PAGE_CNT)
  const [linkCurrentPage, setLinkCurrentPage] = useState(1)
  const [isOpenYoutube, setOpenYoutube] = useState(true)
  const [isYoutubeCheckBox, setYoutubeCheckbox] = useState(false)

  const [isExtensionInstalled, setIsExtensionInstalled] =
    useState<boolean>(false)

  const {
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: defaultValues,
  })
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'products',
    rules: {
      maxLength: 5,
    },
  })

  const translatePlanName = (planName: string) => {
    let tPlanName = ''
    switch (planName) {
      case '라이트':
        tPlanName = 'LIGHT'
        break
      case '프로':
        tPlanName = 'PRO'
        break
      case '프리미엄':
        tPlanName = 'PREMIUM'
        break
    }
    return tPlanName
  }

  const paymentFreePlan = () => {
    if (!userPlanInfo && userInfo?.experiencedUser) {
      return setPlanPriceModal(true)
    }
    if (!userInfo?.userInfo) {
      navigate('/sign-up')
      return
    } else if (userInfo && userInfo?.userType === UserType.체험) {
      return
    }

    experiencePlanMutate('', {
      onSuccess: (data) => {
        refetch()
        planRefetch()
      },
      onError: (e) => {
        console.log(e)
      },
    })
  }

  const scrollToRef = useRef<HTMLDivElement>(null)
  const handleScroll = () => {
    if (scrollToRef.current) {
      // scrollIntoView를 사용해 해당 위치로 스크롤
      scrollToRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    }
  }

  const handleScrollToDivRef = (divRef: React.RefObject<HTMLDivElement>) => {
    if (divRef.current) {
      // scrollIntoView를 사용해 해당 위치로 스크롤
      divRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    }
  }

  const onSubmit = async (data: FormValues) => {
    if (!userInfo) {
      return navigate('/sign-up')
    }
    if (createVideoType === CreateVideoType.PRODUCT_LONG) {
      const formData = await createLongFormVideoFormData(
        data,
        userInfo,
        setRequest,
        isAIGenerated,
        setErrorText,
        scrollToProducts,
        setEssentialCheck,
        isOpenLinkMethod,
        selectedLinkIds,
        myPointMutateAsync,
        setFailWithShortModal,
        thumbNailDivRef,
        transitionDivRef,
        isRequest,
        watch
      )
      try {
        if (formData) {
          mutate(formData, {
            onSuccess: () => {
              longFormCreateBtnClick()
              setRequest(true)
              setSaveSuccessModal((prev) => !prev)
              removeLocalStorage(LOCAL_THUMBNAIL_INFO)
              scrollToProducts()
            },
            onError: (e: any) => {
              //@ts-ignore
              const serverErrorMsg = e.response?.data?.message || e.message
              const errorType = e.response?.data?.error
              const status = e?.response?.status
              if (status === 413) {
                setErrorTitle('🚨 첨부파일 용량을 확인해주세요!')
                setErrorText('첨부된 파일이 총 20MB를 넘지 않게 조절해주세요')
              } else if (errorType === 'maxSize') {
                setErrorTitle('🚨 첨부파일 용량을 확인해주세요!')
                setErrorText('첨부된 파일이 개당 5MB를 넘지 않게 조절해주세요.')
              } else {
                setErrorTitle('🙌 필수 정보를 확인해주세요!')
                setErrorText(serverErrorMsg)
              }
              setRequest(true)
              setEssentialCheck(true)
            },
          })
        }
      } catch (error: any) {
        setRequest(true)
        if (error?.message === 'extensionCollectId is Undefined') {
          setErrorTitle('⚠️ 영상 생성 중 오류가 발생했어요.')
          setErrorText(
            <>
              <p>화면 오른쪽 아래 [민트색 상담톡 버튼] 클릭 {`>`} </p>
              <p> [🚨영상 오류 문의] 클릭 {'>'} "생성중 오류" </p>
              <p>
                {' '}
                라고 입력해주세요! 확인 후{' '}
                <span className="font-bold text-main">3,000캐시</span>{' '}
                드릴게요!`{' '}
              </p>
            </>
          )
          scrollToProducts()
          setEssentialCheck(true)
        }
      }
    } else if (createVideoType === CreateVideoType.PRODUCT_SHORT) {
      const fastcutProductShortData = await createShortFormVideoData(
        data,
        subTitleList,
        bgmList
      )
      try {
        if (fastcutProductShortData) {
          createFastCutProductShortMutate(fastcutProductShortData, {
            onSuccess: () => {
              setRequest(true)
              setSaveSuccessModal((prev) => !prev)
              removeLocalStorage(LOCAL_THUMBNAIL_INFO)
              scrollToProducts()
            },
            onError: (e: any) => {
              //@ts-ignore
              const serverErrorMsg = e.response?.data?.message || e.message
              const errorType = e.response?.data?.error
              const status = e?.response?.status
              if (status === 413) {
                setErrorTitle('🚨 첨부파일 용량을 확인해주세요!')
                setErrorText('첨부된 파일이 총 20MB를 넘지 않게 조절해주세요')
              } else if (errorType === 'maxSize') {
                setErrorTitle('🚨 첨부파일 용량을 확인해주세요!')
                setErrorText('첨부된 파일이 개당 5MB를 넘지 않게 조절해주세요.')
              } else {
                setErrorTitle('🙌 필수 정보를 확인해주세요!')
                setErrorText(serverErrorMsg)
              }
              setRequest(true)
              setEssentialCheck(true)
            },
          })
        }
      } catch (error: any) {
        setRequest(true)
        if (error?.message === 'extensionCollectId is Undefined') {
          setErrorTitle('⚠️ 영상 생성 중 오류가 발생했어요.')
          setErrorText(
            <>
              <p>화면 오른쪽 아래 [민트색 상담톡 버튼] 클릭 {`>`} </p>
              <p> [🚨영상 오류 문의] 클릭 {'>'} "생성중 오류" </p>
              <p>
                {' '}
                라고 입력해주세요! 확인 후{' '}
                <span className="font-bold text-main">3,000캐시</span>{' '}
                드릴게요!`{' '}
              </p>
            </>
          )
          scrollToProducts()
          setEssentialCheck(true)
        }
      }
    }
  }

  const toggleContent = () => {
    handleScrollToDivRef(thumbNailDivRef)
    setIsOpen(!isOpen)
  }

  const [videoPlaying, setVideoPlaying] = useState<boolean[]>(
    new Array(transitionList?.length).fill(false)
  )

  const [voicePlaying, setVoicePlaying] = useState<boolean[]>(
    new Array(voiceList?.length).fill(false)
  )

  const [bgmPlaying, setBgmPlaying] = useState<boolean[]>(
    new Array(bgmList?.length).fill(false)
  )

  const [toneTooltip, setToneTooltip] = useState<boolean[]>([])
  const [promptStatus, setPromptStatus] = useState<boolean[]>([])

  //여러개 tooltip 관리

  const handleMouseLeave = (index: number) => {
    if (videoRefs.current[index]) {
      try {
        videoRefs.current[index]!.currentTime = 1
        videoRefs.current[index]!.pause()
      } catch (e) {
        console.log(e, 'not pause video index:', index)
      }
    }
  }

  // bgm / transition / voice handle function 부분
  const videoRefs = useRef<(HTMLVideoElement | null)[]>([])
  const videoRef = useRef<HTMLVideoElement | null>(null)
  const bgmRefs = useRef<(HTMLAudioElement | null)[]>([])

  const handleBgmPlayButtonClick = (status: boolean, index: number) => {
    const updatedPlayingState = bgmPlaying.map((value, idx) =>
      idx === index ? status : false
    )
    setBgmPlaying(updatedPlayingState)

    if (bgmRefs.current[index]) {
      if (status) {
        bgmRefs.current[index]?.play()
      } else {
        bgmRefs.current[index]?.pause()
      }
    }
  }

  const handleSelectedTransition = (behavior: boolean) => {
    if (videoRef.current && behavior) {
      if (videoRef.current!.readyState >= 2) {
        try {
          videoRef.current!.muted = true
          videoRef.current!.currentTime = 0
          videoRef.current?.play().catch((error) => {
            console.warn('Playback failed:', error)
          })
        } catch (e) {
          console.log(e, 'not play video index:')
        }
      }
    } else if (videoRef.current && !behavior) {
      if (videoRef.current!.readyState >= 2) {
        try {
          videoRef.current!.currentTime = 1
          videoRef.current?.pause()
        } catch (e) {
          console.log(e, 'not play video index:')
        }
      }
    }
  }

  const handleVideoEnded = (index: number) => {
    const updatedPlayingState = [...videoPlaying]
    updatedPlayingState[index] = false
    setVideoPlaying(updatedPlayingState)
  }

  const handlePlayButtonClick = (index: number) => {
    const updatedPlayingState = videoPlaying.map((value, idx) =>
      idx === index ? true : false
    )
    setVideoPlaying(updatedPlayingState)
  }

  const isFreePlanOrUser = () => {
    if (!userInfo) {
      return (
        <FreePlanBanner
          SetFreePlanModal={SetFreePlanModal}
          paymentFreePlan={paymentFreePlan}
        />
      )
    } else if (
      userInfo &&
      userInfo?.userType === UserType.USER &&
      !userInfo?.experiencedUser
    ) {
      return (
        <FreePlanBanner
          SetFreePlanModal={SetFreePlanModal}
          paymentFreePlan={paymentFreePlan}
        />
      )
    }
    return null
  }

  const handleLoadedMetadata = (index: number) => {
    if (videoRefs.current[index]) {
      videoRefs.current[index]!.currentTime = 1
      videoRefs.current[index]!.pause()
    }
  }
  const handleInitData = () => {
    initSetValue(setValue, watch)
    setPlacIdThumbnail([])
    setIsSaveThumbnail(false)
    setAiRecommendClipTitle(null)
    setAiRecommendThumbnailTitle(null)
    setPlacIdThumbnail([])
    setOpenExtensionMethod(false)
    setOpenLinkMethod(false)
    setSelectedLinkIds([])
    setSelectedLinks([])
    setAiRecommendClipTitle(null)
    setSelectedPlacIdThumbnail(null)
    setSelectedItem(null)
  }

  const setVideoData = () => {
    if (!videoEditorData) {
      //* 기존 저장 정보가 없을때 각 list의 default로 셋팅이 되어야함 // initializeDefaults 대체
      initializeDefaults({
        setValue,
        aiPromptGroup,
        voiceList,
        transitionList,
        introList,
        outroList,
        bgmList,
        subTitleList,
        stickerList,
        stickerLocationList,
        subtitleColorList,
        subtitleFontList,
        subtitleSizeList,
        setPromptStatus,
        setToneTooltip,
        setCopyOutroList,
        setCopyTransitionList,
      })
      return
    }

    const {
      voiceId,
      userVoiceId,
      bgmId,
      transitionId,
      aiPromptTypeId,
      aiToneTypeId,
      subtitleId,
      introId,
      includePrice,
      outroId,
      stickerLocation,
      stickerId,
      includeAdd,
      subtitleColorId,
      subtitleFontId,
      subtitleSizeId,
    } = videoEditorData

    setPromptGroupDataFromList(
      aiPromptGroup,
      setValue,
      setToneTooltip,
      aiPromptTypeId,
      aiToneTypeId
    )

    setVideoDataValueFromList(voiceList, setValue, 'voiceId', Number(voiceId))

    setVideoDataValueFromList(
      transitionList,
      setValue,
      'transitionId',
      Number(transitionId)
    )

    setVideoDataValueFromList(
      subTitleList,
      setValue,
      'subtitleId',
      Number(subtitleId)
    )
    setVideoDataValueFromList(introList, setValue, 'introId', Number(introId))
    setVideoDataValueFromList(
      stickerList,
      setValue,
      'stickerId',
      Number(stickerId)
    )
    setVideoDataValueFromList(outroList, setValue, 'outroId', Number(outroId))

    setVideoDataValueFromListNoUsable(
      userVoiceList,
      setValue,
      'userVoiceId',
      Number(userVoiceId)
    )

    setVideoDataValueNoUsable(
      subtitleFontList,
      setValue,
      'subtitleFontId',
      subtitleFontId
    )

    setVideoDataValueNoUsable(
      subtitleSizeList,
      setValue,
      'subtitleSizeId',
      subtitleSizeId
    )

    //! -- 여기서부터는 list가 plan에 묵여있지 않아서 usable이 없이 그냥 선택 가능한 속성
    setValue('bgmId', bgmId)
    setValue('includePrice', includePrice)
    setValue('includeAdd', includeAdd)
    setValue('stickerLocation', stickerLocation)
    setValue('subtitleColorId', subtitleColorId)
  }
  useEffect(() => {
    const userType = userInfo?.userType
    if (voiceList) setVoicePlaying(new Array(voiceList.length).fill(false))
    if (bgmList) setBgmPlaying(new Array(bgmList.length).fill(false))
    if (aiPromptGroup)
      setPromptStatus(new Array(aiPromptGroup.length).fill(false))
    if (transitionList) {
      setVideoPlaying(new Array(transitionList.length).fill(false))
      setCopyTransitionList(transitionList)
    }
    if (outroList) setCopyOutroList(outroList)
    if (userInfo) {
      userType === UserType['숏폼 스페셜']
        ? setCreateVideoType(CreateVideoType.PRODUCT_SHORT)
        : setCreateVideoType(CreateVideoType.PRODUCT_LONG)

      if (
        userInfo?.userType === UserType.체험 &&
        Number(userInfo?.usage?.usedCount) === 0
      ) {
        setGuideModal(isTime ? false : true)
      }
      setUsage(userInfo.usage)
    }
    if (userType === UserType['숏폼 스페셜']) {
      loadProductShortData(
        productShortData,
        setValue,
        aiPromptGroup,
        voiceList,
        userVoiceList,
        bgmList,
        subTitleList,
        subtitleColorList,
        subtitleFontList,
        subtitleSizeList,
        setPromptStatus,
        setToneTooltip
      )
    } else {
      setVideoData()
    }
  }, [
    userInfo,
    outroList,
    subTitleList,
    subtitleColorList,
    aiPromptGroup,
    transitionList,
    bgmList,
    voiceList,
    stickerList,
    stickerLocationList,
    userVoiceList,
  ])

  useEffect(() => {
    if (isTime === '1') {
      bgmRefetch()
      transitonRefetch()
      voiceRefetch()
      aiPromptGroupRefetch()
      thumbnailRefetch()
    }
  }, [isTime])

  useEffect(() => {
    bgmRefs.current.forEach((audioRef, index) => {
      if (audioRef && !bgmPlaying[index]) {
        audioRef.pause()
        audioRef.currentTime = 0
      }
    })
  }, [bgmPlaying])

  useEffect(() => {
    if (refetch) {
      refetch()
    }
  }, [])

  const chartElByTab = () => {
    return (
      <>
        {userInfo?.userType === UserType.라이트 && (
          <>
            <LightPlan
              subscriptionType={
                userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
              }
              startDate={userPlanInfo?.subscriptions?.startDate ?? '--'}
              endDate={userPlanInfo?.subscriptions?.endDate ?? '--'}
              currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
              subscriptions={userPlanInfo?.subscriptions}
              monthStart={userPlanInfo?.subscriptions.monthStart ?? '--'}
              monthEnd={userPlanInfo?.subscriptions.monthEnd ?? '--'}
            />
          </>
        )}
        {(userInfo?.userType === UserType.프로 ||
          userInfo?.userType === UserType.프리미엄 ||
          userInfo?.userType === UserType['숏폼 스페셜']) &&
        userInfo?.subscriptions?.subscriptionType === 'annual' ? (
          <>
            <ProAndPremiumPlanAnnual
              userType={userInfo?.userType}
              subscriptionType={
                userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
              }
              startDate={userPlanInfo?.subscriptions?.monthStart ?? '--'}
              endDate={userPlanInfo?.subscriptions?.monthEnd ?? '--'}
              currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
              available={userPlanInfo?.usage?.available ?? false}
              couponBenefit={userInfo?.couponBenefit}
              isDone={userPlanInfo?.usage?.isDone}
              subscriptions={userPlanInfo?.subscriptions}
            />
          </>
        ) : (
          (userInfo?.userType === UserType.프로 ||
            userInfo?.userType === UserType.프리미엄 ||
            userInfo?.userType === UserType['숏폼 스페셜']) &&
          userInfo?.subscriptions?.subscriptionType === 'monthly' && (
            <>
              {' '}
              <ProAndPremiumPlanMonthly
                userType={userInfo?.userType}
                subscriptionType={
                  userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
                }
                startDate={userPlanInfo?.subscriptions?.startDate ?? '--'}
                endDate={userPlanInfo?.subscriptions?.endDate ?? '--'}
                currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
                available={userPlanInfo?.usage?.available ?? false}
                isDone={userPlanInfo?.usage?.isDone}
                couponBenefit={userInfo?.couponBenefit}
                subscriptions={userPlanInfo?.subscriptions}
              />
            </>
          )
        )}
        {userInfo?.userType === UserType.USER && (
          <>
            <EmptyPlan
              subscriptionType={
                userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
              }
              startDate={userPlanInfo?.subscriptions?.startDate ?? '--'}
              endDate={userPlanInfo?.subscriptions?.endDate ?? '--'}
              currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
              setPlanPriceModal={setPlanPriceModal}
            />
          </>
        )}
        {userInfo?.userType === UserType.체험 && (
          <>
            <FreePlan
              userType={userInfo?.userType}
              subscriptionType={
                userPlanInfo?.planPrice?.planPrice[0].subscriptionType ?? ''
              }
              startDate={userPlanInfo?.subscriptions?.startDate ?? '--'}
              endDate={userPlanInfo?.subscriptions?.endDate ?? '--'}
              currentMonth={userPlanInfo?.subscriptions?.currentMonth ?? ''}
              totalLimit={userPlanInfo?.usage?.totalLimit ?? 0}
              usedCount={userPlanInfo?.usage?.usedCount ?? 0}
              available={userPlanInfo?.usage?.available ?? false}
              couponBenefit={userInfo?.couponBenefit}
              isDone={userPlanInfo?.usage?.isDone}
              subscriptions={userPlanInfo?.subscriptions}
            />
          </>
        )}
      </>
    )
  }

  const handlePriceModal = () => {
    /**
     * userInfo는 있고
     * 유저타입이 일반은 사람에게만 띄우기
     * 1.예전에 체험을 해본사람
     * 2. 무료체험 완료한사람
     * 3. 무료체험 신청전 일반유저
     */
    if (!userInfo) {
      navigate('/sign-up')
      return
    }
    if (!userPlanInfo && userInfo?.userType === UserType.체험) {
      return setPlanPriceModal((prev) => !prev)
    }
    if (userInfo?.userType === UserType.체험) {
      const totalLimit = Number(userInfo?.usage?.totalLimit)
      const usedCount = Number(userInfo?.usage?.usedCount)
      if (totalLimit === usedCount) {
        return setPlanPriceModal((prev) => !prev)
      }
    }
    if (userInfo?.userType === UserType.USER) {
      return setPlanPriceModal((prev) => !prev)
    }
  }

  const scrollToProducts = () => {
    console.log('scroll', productsRef)
    if (productsRef.current) {
      productsRef.current.focus()
      productsRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    }
  }

  const selectErrorText = (
    mainTitle?: any,
    products?: any,
    thumbnailInfo?: any,
    subtitleId?: any
  ) => {
    const checkProducts = watch('products')
    const res = checkProducts.filter((el) => !el.link.trim())
    if (res.length === 3) {
      setErrorText(
        '최소 1개의 상품 링크 입력을 하셔야 영상 생성 요청이 가능합니다.'
      )
      scrollToProducts()
      return
    }

    if (products) {
      // 에러가 1~3개 까지 발생가능
      // 각각 링크와 상품명에 대해서 발생 가능
      // text => 상품 1의 상품명을 입력해주세요
      for (const product of products) {
        if (product) {
          const { link, productName } = product
          const linkIndex = link?.ref?.name.replace(
            /products|\blink\b|\.|/g,
            ''
          )
          const nameIndex = productName?.ref?.name.replace(
            /products|\bproductName\b|\.|/g,
            ''
          )
          if (link?.type === 'validate' || link?.type === 'required') {
            setErrorText(`상품 ${Number(linkIndex) + 1}의 링크를 확인해주세요.`)
            scrollToProducts()
            return
          } else if (productName?.message === 'required') {
            setErrorText(
              `상품 ${Number(nameIndex) + 1}의 상품명을 입력해주세요`
            )

            scrollToProducts()
            return
          } else if (productName?.type === 'maxLength') {
            setErrorText(
              `상품 ${Number(nameIndex) + 1}의 상품명 글자 수가 초과되었어요`
            )

            scrollToProducts()
            return
          }
        }
      }
    }
    if (mainTitle) {
      const { type } = mainTitle
      if (type === 'required') {
        setErrorText('유튜브 영상용 제목을 입력해주세요.')
      } else {
        setErrorText('유튜브 영상용 제목 글자 수가 초과되었어요')
      }
      if (mainTitleInputRef.current) {
        mainTitleInputRef.current.focus()
        mainTitleInputRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
      }
      return
    }
    if (thumbnailInfo) {
      setErrorText('썸네일 스타일과 썸네일 내용을 입력해주세요')
      if (thumbNailDivRef.current) {
        thumbNailDivRef.current.focus()
        thumbNailDivRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })
      }
      return
    }

    if (subtitleId) {
      setErrorText('나레이션 자막 삽입 여부를 선택해주세요')
      if (subtitleDivRef.current) {
        subtitleDivRef.current.focus()
        subtitleDivRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
      }
      return
    }
    setErrorText('errors')
  }

  const findError = (mainTitle: any, products: any, thumbnail: any) => {
    const updateError = { ...error }
    //1. mainTtitle
    if (mainTitle) {
      updateError.mainTitle = true
    } else {
      updateError.mainTitle = false
    }
    if (thumbnail) {
      updateError.thumbnail = true
    } else {
      updateError.thumbnail = false
    }
    if (products) {
      for (const product of products) {
        if (product) {
          const { link, productName } = product

          if (link) {
            const linkIndex = link?.ref?.name.replace(
              /products|\blink\b|\.|/g,
              ''
            )
            updateError.products[linkIndex].link = true
          }
          if (productName) {
            const nameIndex = productName?.ref?.name.replace(
              /products|\bproductName\b|\.|/g,
              ''
            )
            updateError.products[nameIndex].product = true
          }
        }
      }
    } else {
      updateError.products = [
        { link: false, product: false },
        { link: false, product: false },
        { link: false, product: false },
      ]
    }

    setError(updateError)
  }

  // useEffect 내부에서 사용

  return (
    <>
      <Helmet>
        <title>{t('productVideoEditor.meta.title')}</title>
        <meta
          name="description"
          content={t('productVideoEditor.meta.description')}
        />
        <link
          rel="canonical"
          href="https://fastcut.fastseller.shop/video-editor"
        />
      </Helmet>
      <div className="md:w-[816px] w-[375px] my-0 mx-auto flex flex-col items-center gap-[16px] relative">
        {/* 회원 / 비회원 타이틀 다르게 */}
        {userInfo ? (
          <MemberTitle
            userInfo={userInfo}
            createVideoType={createVideoType}
            isExtensionInstalled={isExtensionInstalled}
          />
        ) : (
          <NoneMemberTitle
            userInfo={userInfo}
            isExtensionInstalled={isExtensionInstalled}
          />
        )}
        {/* 페이백 배너 렌더링 */}

        {createVideoType !== CreateVideoType.PRODUCT_SHORT &&
          renderPaybackVideo(userInfo)}
        {/* 무료체험 배너 */}
        {!isMobile && isFreePlanOrUser()}
        {/* 현황 데시보드 */}

        <AuthGuard userInfo={userInfo}>
          <div className="flex flex-col rounded-b-[20px] md:rounded-tr-[20px] rounded-t-[20px] bg-[#F6F8FB] md:px-10 md:py-8 p-[10px] md:w-full w-[343px]   ">
            <div className="name mb-2    ">
              {userInfo?.userInfo?.name}
              {` `}({userInfo?.userInfo?.email}){` `}님
            </div>
            <div className="  flex flex-col md:flex-row gap-4 md:justify-between relative items-center">
              {chartElByTab()}
            </div>
            <FastclickDashBoard userInfo={userInfo} blockWidth="w-full" />
          </div>
        </AuthGuard>

        {/* 유튜브 / 업그레이드 / 사용소진 / 미션쿠폰 등 */}
        <div className="flex flex-col gap-5 items-center md:w-[776px] w-[343px]">
          {userInfo?.couponBenefit && (
            <div className="md:w-full w-[343px] flex justify-center">
              <button
                className="bg-main text-white w-full h-[42px] rounded-[40px]"
                style={{
                  background: 'linear-gradient(to right, #6095FF, #D512E7)',
                }}
              >
                <span className="font-[800] font-[Tenada]">
                  {userInfo.couponBenefit.couponDescription}
                </span>
              </button>
            </div>
          )}{' '}
          <div className="w-full flex flex-col gap-5 md:flex-row md:gap-[14px] md:justify-center items-center ">
            {userInfo?.affiliate?.plan?.length > 0 && (
              <PlanPromotionBanner
                daysLeft={userInfo?.affiliate.plan[0].daysLeft}
                hoursLeft={userInfo?.affiliate.plan[0].hoursLeft}
                affiliateImage={userInfo?.affiliate.plan[0].affiliateImage}
                affiliateDescription={
                  userInfo?.affiliate.plan[0].affiliateDescription
                }
                description={userInfo?.affiliate.plan[0].description}
              />
            )}
            {showYoutubeAuth(
              userInfo,
              'flex justify-center items-center w-[343px] h-[46px] bg-error text-white font-bold text-[14px] rounded-[40px]'
            )}
            <PromotionCircle
              userInfo={userInfo}
              planId={userInfo?.subscriptionType?.planId}
              classNameProps="w-full h-[34px]  rounded-full text-white font-bold"
            />
          </div>
          {/* 횟수 제한 표시 dic */}
          {userInfo &&
            usage &&
            !usage?.available &&
            userInfo?.userType !== UserType.체험 && (
              <div
                className="bg-[#F6F8FB] md:w-[816px]  md:h-[46px] flex md:flex-row 
               w-[343px] h-[58px] flex-col items-center justify-center rounded-[40px] md:gap-[18px] "
              >
                <p className="font-bold md:text-[18px] text-[14px]">
                  기한 내 사용 가능 횟수를 모두 소진하셨어요!
                </p>
                <p className="font-bold md:text-[18px] text-[14px]">
                  <span className="text-main">요청 {usage.usedCount}개</span> /{' '}
                  {usage?.totalLimit}개
                </p>
              </div>
            )}
        </div>

        {isOpenYoutube && !video_page_youtube && (
          <div className="flex flex-col">
            <div className="flex justify-end items-center">
              <input
                type="checkbox"
                className="h-[18px] w-[18px] mr-1"
                onClick={() => {
                  setYoutubeCheckbox((prev) => !prev)
                }}
                checked={isYoutubeCheckBox}
              />
              <p>확장 프로그램 안내 영상 다시 보지 않기</p>
              <img
                src="assets/img/icon_x.png"
                alt=""
                className="w-[24px] h-[24px] cursor-pointer"
                onClick={() => {
                  saveLocalStorage('vpy', isYoutubeCheckBox)
                  setOpenYoutube((prev) => !prev)
                }}
              />
            </div>
            <YouTube
              videoId={'VMJKnYM8rH4'}
              opts={{
                width: isMobile ? '343' : '816',
                height: isMobile ? '193' : '495',
                playerVars: {
                  autoplay: 1, // 자동 재생
                },
              }}
            />
          </div>
        )}

        <form
          onClick={handlePriceModal}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              console.log('Enter key detected but prevented submission')
            }
          }}
          onSubmit={handleSubmit(onSubmit, (err) => {
            if (!userInfo) {
              return navigate('/sign-up')
            }
            if (window.gtag) {
              // Event snippet for 영상생성요청클릭 conversion page

              window.gtag('event', 'conversion', {
                send_to: 'AW-677452397/OM8ECK_B3IwaEO20hMMC',
                value: 1.0,
                currency: 'KRW',
              })
            } else {
              console.error('gtag is not defined')
            }

            const { mainTitle, products, thumbnailInfo, subtitleId } = err
            console.log(err)

            findError(mainTitle, products, thumbnailInfo)
            selectErrorText(mainTitle, products, thumbnailInfo, subtitleId)
            setEssentialCheck(true)
          })}
          className={`flex flex-col gap-[20px]  ${
            usage &&
            userInfo?.userType !== UserType.체험 &&
            !usage?.available &&
            'opacity-[0.2]'
          }`}
        >
          {/* 스크립트 생성 방법  */}
          <ScriptInputModeToggle watch={watch} setValue={setValue} />

          <ShadowBox className="md:w-[816px] w-[375px]">
            <div
              className={classNames(
                'flex flex-col items-center gap-[4px] md:gap-[16px] w-[375px] md:w-[736px]',
                { 'px-4': isMobile }
              )}
            >
              <div className="flex flex-col items-center mt-[40px] md:mt-0 w-[343px] md:w-full">
                <h3 className="font-bold text-[#2E343D] text-[24px] ">
                  {t('productVideoEditor.sections.productSelection.title')}
                </h3>
                <p className="text-[#8F929B] text-[14px]">
                  {t('productVideoEditor.sections.productSelection.description')}
                </p>
              </div>

              <div
                className="flex flex-col gap-[16px] mt-1  w-[375px] md:w-[736px] "
                ref={productsRef}
              >
                <div className=" ">
                  <div
                    className={classNames('', {
                      'flex flex-col gap-2': !isMobile,
                      'flex flex-col items-center justify-center': isMobile,
                    })}
                  >
                    <button
                      className={classNames(
                        'text-[14px] font-bold text-white bg-main rounded-full h-[48px]  flex items-center justify-center gap-2',
                        {
                          'w-full': !isMobile,
                          'w-[343px]': isMobile,
                        }
                      )}
                      type="button"
                      onClick={() => {
                        if (isOpenLinkMethod && !isOpenExtensionMethod) {
                          setOpenLinkMethod(false)
                        }
                        setOpenExtensionMethod((prev) => !prev)
                      }}
                    >
                      <UlClipBoardIcon />
                      {t('productVideoEditor.sections.productSelection.selectFromExtension')}
                    </button>
                    {isMobile ? (
                      <>
                        {' '}
                        <p
                          className={classNames(
                            'flex items-center gap-1 text-[14px] mt-2 relative',
                            { 'w-full px-4': isMobile }
                          )}
                        >
                          {' '}
                          <img
                            src="assets/img/icon_tooltip.png"
                            alt="툴팁"
                            className=" w-[24px] h-[24px]"
                            onMouseOver={() => {
                              setOpenExtensionTooltip((prev) => !prev)
                            }}
                          />
                          {t('productVideoEditor.tooltips.extensionInfo')}
                          <a
                            className="flex gap-2  text-[14px] items-center cursor-pointer ml-1"
                            href="https://www.youtube.com/watch?v=VMJKnYM8rH4"
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src="assets/img/icon_youtube.png"
                              alt="icon_youtube"
                              className="w-[26px] h-[26px]"
                            />
                            <span className="font-bold">
                              {t('productVideoEditor.tooltips.extensionGuide')}
                            </span>{' '}
                          </a>
                          {isOpenExtensionTooltip && (
                            <ExtensionTooltip
                              setOpenExtensionTooltip={setOpenExtensionTooltip}
                            />
                          )}
                        </p>
                      </>
                    ) : (
                      //pc 3가지 버튼
                      <>
                        <p className="w-full bg-[#EEF1F7] rounded-[10px] justify-evenly h-[42px] flex items-center relative">
                          <button
                            className="flex gap-1 text-[14px] items-center"
                            type="button"
                            onClick={() => {
                              setOpenExtensionTooltip(true)
                            }}
                          >
                            <span className="text-[24px]"> ☝️</span>
                            {t('productVideoEditor.tooltips.extensionCheck')}
                          </button>
                          <button
                            className="flex gap-1 text-[14px] items-center"
                            type="button"
                            onClick={() => {
                              window.open(
                                'https://www.youtube.com/watch?v=VMJKnYM8rH4'
                              )
                            }}
                          >
                            <img
                              src="assets/img/icon_youtube.png"
                              alt="youtube"
                              className="w-[26px] h-[26px]"
                            />
                            {t('productVideoEditor.tooltips.videoGuide')}
                          </button>
                          <button
                            className="flex gap-1 text-[14px] items-center"
                            type="button"
                            onClick={() => {
                              setOpenExtensionErrorGuideTooltip(true)
                            }}
                          >
                            {' '}
                            <span className="text-[24px]"> 🚨</span>
                            {t('productVideoEditor.tooltips.errorSolution')}
                          </button>
                          {isOpenExtensionTooltip && (
                            <ExtensionTooltip
                              setOpenExtensionTooltip={setOpenExtensionTooltip}
                            />
                          )}
                          {isOpenExtensionErrorGuideTooltip && (
                            <ExtensionErrorGuideTooltip
                              setOpenExtensionErrorGuideTooltip={
                                setOpenExtensionErrorGuideTooltip
                              }
                            />
                          )}
                        </p>
                      </>
                    )}
                  </div>
                </div>
                {/* 새로운 창 */}

                {/* {isOpenLinkMethod && !isOpenExtensionMethod && (
                  <ProductListV1
                    watch={watch}
                    setValue={setValue}
                    control={control}
                    errors={errors}
                    error={error}
                    fields={fields}
                    userInfo={userInfo}
                    setErrorText={setErrorText}
                    setError={setError}
                    usage={usage}
                    isImageDivOpen={isImageDivOpen}
                    setImageDivOpen={setImageDivOpen}
                    productsRef={productsRef}
                    setTooltipStatus={setTooltipStatus}
                    tooltipStatus={tooltipStatus}
                  />
                )} */}
                <div className="w-full flex justify-center">
                  {fields.length < 3 && (
                    <button
                      type="button"
                      onClick={() => {
                        if (fields.length < 3) {
                          append({
                            link: '',
                            productName: '',
                            userScript: '',
                            files: [],
                            extensionCollectId: 0,
                            selectedFiles: [],
                            selectedDetails: [],
                            selectedThumbnails: [],
                            selectedVideos: [],
                            selectedVideoTotalDuration: 0,
                            withShort: 0,
                            subtitleFlag: 0,
                            bgmFlag: 0,
                            purchaseInfoFlag: 0,
                            productTemplateId: 0,
                            productTitle: '',
                            saveProductTemplateId: 0,
                            saveProductTitle: '',
                          })
                        }
                      }}
                    >
                      <img
                        src="assets/img/add.png"
                        height={32}
                        width={32}
                        alt="add"
                      />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </ShadowBox>
          {watch('products.0.link') === '' && (
            <FeatureDescription
              description1="수집한 상품을 선택"
              description1_1=" 해주시면"
              description2="상품별 내용 편집 기능"
            />
          )}
          <ShadowBox>
            <div
              className={classNames(
                'flex flex-col items-center gap-[4px] md:gap-[16px] w-[375px] md:w-[736px]',
                {
                  'px-4': isMobile,
                  'opacity-50':
                    !isOpenLinkMethod && selectedLinkIds.length === 0,
                }
              )}
            >
              <div className="flex flex-col items-center mt-[40px] md:mt-0 w-[343px] md:w-full">
                <h3 className="font-bold text-[#2E343D] text-[24px] ">
                  {createVideoType === CreateVideoType.PRODUCT_LONG
                    ? t('productVideoEditor.sections.productEdit.titleLong')
                    : t('productVideoEditor.sections.productEdit.titleShort')}
                </h3>
                <p className="text-[#8F929B] text-[14px]">
                  {t('productVideoEditor.sections.productEdit.description')}
                </p>
              </div>
              {!isOpenLinkMethod && selectedLinkIds.length > 0 ? (
                <ProductList
                  watch={watch}
                  setValue={setValue}
                  control={control}
                  errors={errors}
                  error={error}
                  fields={fields}
                  userInfo={userInfo}
                  setErrorText={setErrorText}
                  setError={setError}
                  usage={usage}
                  selectedLinks={selectedLinks}
                  isAiName={isAiName}
                  promptGroupList={aiPromptGroup ?? []}
                  setPromptStatus={setPromptStatus}
                  setToneTooltip={setToneTooltip}
                  promptStatus={promptStatus}
                  toneTooltip={toneTooltip}
                  translatePlanName={translatePlanName}
                  createVideoType={createVideoType}
                />
              ) : (
                !isOpenLinkMethod &&
                selectedLinkIds.length === 0 && (
                  <>
                    <ProductItemEmpty
                      watch={watch}
                      setValue={setValue}
                      control={control}
                      errors={errors}
                      error={error}
                      fields={fields}
                      userInfo={userInfo}
                      setErrorText={setErrorText}
                      setError={setError}
                      usage={usage}
                      selectedLinks={selectedLinks}
                      isAiName={isAiName}
                      isOpenLinkMethod={isOpenLinkMethod}
                      isOpenExtensionMethod={isOpenExtensionMethod}
                      setOpenLinkMethod={setOpenLinkMethod}
                      setOpenExtensionMethod={setOpenExtensionMethod}
                    />
                  </>
                )
              )}
            </div>
          </ShadowBox>

          {!isOpenLinkMethod &&
            selectedLinkIds.length > 0 &&
            createVideoType === CreateVideoType.PRODUCT_LONG && (
              <WithShortFormCreate
                watch={watch}
                setValue={setValue}
                control={control}
                userInfo={userInfo}
                selectedLinks={selectedLinks}
              />
            )}

          {createVideoType === CreateVideoType.PRODUCT_LONG && (
            <YoutubeTitle
              watch={watch}
              control={control}
              setValue={setValue}
              userInfo={userInfo}
              clipTitleIsPending={clipTitleIsPending}
              thumbnailIsPending={thumbnailIsPending}
              aiRecommendClipTitle={aiRecommendClipTitle}
              mainTitleInputRef={mainTitleInputRef}
              setError={setError}
              error={error}
              usage={usage}
            />
          )}

          <ShadowBox className="py-[40px] px-[16px] md:w-[816px] relative ">
            {watch('products.0.link') === '' && (
              <div className="py-[40px] px-[16px] md:w-[816px] w-full h-full bg-white absolute z-50 left-0 opacity-50"></div>
            )}
            <div
              className="flex flex-col gap-[40px] md:gap-0 w-[343px] md:w-[736px]"
              ref={thumbNailDivRef}
            >
              <div className="flex flex-col items-center  mt-[16px] md:mb-[40px] ">
                <p className="font-bold text-[#2E343D] text-[24px] ">
                  {t('productVideoEditor.sections.effectSelection.title')}
                </p>
                {createVideoType === CreateVideoType.PRODUCT_LONG && (
                  <p className="text-[#FFFFFF] bg-main text-[10px] font-bold w-[159px] text-center rounded-[4px] h-[18px] flex items-center justify-center">
                    <span>{t('productVideoEditor.sections.effectSelection.premiumFeature')}</span>
                  </p>
                )}
                <p className="text-main text-[14px]">
                  {t('productVideoEditor.sections.effectSelection.description')}
                </p>
              </div>

              {createVideoType === CreateVideoType.PRODUCT_SHORT && (
                <>
                  <CSSTransition
                    in={isOpen}
                    timeout={500}
                    classNames="content"
                    unmountOnExit
                  >
                    <FastcutShortformEffectSelector
                      watch={watch}
                      setValue={setValue}
                      control={control}
                      userInfo={userInfo}
                      translatePlanName={translatePlanName}
                      error={error}
                      setError={setError}
                      isOpenLinkMethod={isOpenLinkMethod}
                      selectedLinks={selectedLinks}
                      aiRecommendThumbnailTitle={aiRecommendThumbnailTitle}
                      placIdThumbnail={placIdThumbnail}
                      setPlacIdThumbnail={setPlacIdThumbnail}
                      isSaveThumbnail={isSaveThumbnail}
                      setIsSaveThumbnail={setIsSaveThumbnail}
                      thumbNailDivRef={thumbNailDivRef}
                      selectedPlacIdThumbnail={selectedPlacIdThumbnail}
                      setSelectedPlacIdThumbnail={setSelectedPlacIdThumbnail}
                      selectedItem={selectedItem}
                      setSelectedItem={setSelectedItem}
                      promptGroup={aiPromptGroup}
                      setPromptStatus={setPromptStatus}
                      promptStatus={promptStatus}
                      voiceList={voiceList}
                      userVoiceList={userVoiceList}
                      setVoicePlaying={setVoicePlaying}
                      voicePlaying={voicePlaying}
                      voiceTags={voiceTags}
                      setToneTooltip={setToneTooltip}
                      toneTooltip={toneTooltip}
                      userVoiceRefetch={userVoiceRefetch}
                      subTitleList={subTitleList ?? []}
                      subtitleColorList={subtitleColorList ?? []}
                      subtitleFontList={subtitleFontList ?? []}
                      subtitleSizeList={subtitleSizeList ?? []}
                      subtitleDivRef={subtitleDivRef}
                      bgmList={bgmList ?? []}
                      bgmRefs={bgmRefs}
                      setBgmPlaying={setBgmPlaying}
                      bgmPlaying={bgmPlaying}
                      handleBgmPlayButtonClick={handleBgmPlayButtonClick}
                    />
                  </CSSTransition>
                </>
              )}
              {createVideoType === CreateVideoType.PRODUCT_LONG && (
                <>
                  {' '}
                  <CSSTransition
                    in={isOpen}
                    timeout={500}
                    classNames="content"
                    unmountOnExit
                  >
                    <FastcutLongformEffectSelector
                      watch={watch}
                      setValue={setValue}
                      control={control}
                      userInfo={userInfo}
                      thumbnailList={thumbnailList ?? []}
                      thumbnailPlacIdList={thumbnailPlacIdList ?? []}
                      translatePlanName={translatePlanName}
                      error={error}
                      setError={setError}
                      isOpenLinkMethod={isOpenLinkMethod}
                      selectedLinks={selectedLinks}
                      aiRecommendThumbnailTitle={aiRecommendThumbnailTitle}
                      placIdThumbnail={placIdThumbnail}
                      setPlacIdThumbnail={setPlacIdThumbnail}
                      isSaveThumbnail={isSaveThumbnail}
                      setIsSaveThumbnail={setIsSaveThumbnail}
                      thumbNailDivRef={thumbNailDivRef}
                      selectedPlacIdThumbnail={selectedPlacIdThumbnail}
                      setSelectedPlacIdThumbnail={setSelectedPlacIdThumbnail}
                      selectedItem={selectedItem}
                      setSelectedItem={setSelectedItem}
                      promptGroup={aiPromptGroup}
                      setPromptStatus={setPromptStatus}
                      promptStatus={promptStatus}
                      voiceList={voiceList}
                      userVoiceList={userVoiceList}
                      setVoicePlaying={setVoicePlaying}
                      voicePlaying={voicePlaying}
                      voiceTags={voiceTags}
                      setToneTooltip={setToneTooltip}
                      toneTooltip={toneTooltip}
                      userVoiceRefetch={userVoiceRefetch}
                      subTitleList={subTitleList ?? []}
                      subtitleColorList={subtitleColorList ?? []}
                      subtitleFontList={subtitleFontList ?? []}
                      subtitleSizeList={subtitleSizeList ?? []}
                      subtitleDivRef={subtitleDivRef}
                      bgmList={bgmList ?? []}
                      bgmRefs={bgmRefs}
                      setBgmPlaying={setBgmPlaying}
                      bgmPlaying={bgmPlaying}
                      handleBgmPlayButtonClick={handleBgmPlayButtonClick}
                      copyTransitionList={copyTransitionList}
                      setSelectedTransitionIndex={setSelectedTransitionIndex}
                      selectedTransitionIndex={selectedTransitionIndex}
                      setTransitionModal={setTransitionModal}
                      handlePlayButtonClick={handlePlayButtonClick}
                      handleVideoEnded={handleVideoEnded}
                      handleMouseLeave={handleMouseLeave}
                      handleSelectedTransition={handleSelectedTransition}
                      videoRefs={videoRefs}
                      videoRef={videoRef}
                      transitionDivRef={transitionDivRef}
                      videoPlaying={videoPlaying}
                      introList={introList ?? []}
                      stickerList={stickerList}
                      stickerLocationList={stickerLocationList}
                      copyOutroList={copyOutroList}
                      setCopyOutroList={setCopyOutroList}
                    />
                  </CSSTransition>
                </>
              )}
              <div className="flex items-center justify-center">
                <button
                  className="flex items-center justify-center gap-[8px] w-full py-[12.5px] bg-[#EEF1F7] rounded-[40px]"
                  type="button"
                  onClick={toggleContent}
                >
                  <span>{isOpen ? t('common.buttons.fold') : t('common.buttons.unfold')}</span>
                  <img
                    src="assets/img/icon_up_arrow.png"
                    alt="arrow"
                    className={`w-[12.8px] h-[8.25px]  transition-transform duration-1000 ${
                      isOpen ? '' : 'rotate-180'
                    }`}
                  />
                </button>
              </div>
            </div>
          </ShadowBox>
          <div className="text-[16px] text-center mt-4 relative">
            패스트컷은 사용자가 제공하는 URL에 있는 텍스트/이미지/영상을 토대로
            영상을 만들고 있으며,
            <br /> 링크 내의 텍스트나 이미지, 영상 등이 영상에 사용될 수
            있습니다.
            <br /> 이에 대한 지적재산권 침해 여부는 사용자가 확인하여야 하며,
            이에 관하여 패스트컷은 책임이 없습니다.
            <br />
            <br />
            숏폼용 세로 영상도 함께 생성할 시 ‘패스트클릭’ 링크 서비스를
            사용하며{' '}
            <span
              className="text-href underline font-bold  cursor-pointer"
              onClick={() => {
                setShortFormTooltip((prev) => !prev)
              }}
            >
              약관
            </span>{' '}
            11조 11항, 13조 6항에 동의하는 것입니다.
            {shortFormTooltip && (
              <ShortFormTooltip setShortFormTooltip={setShortFormTooltip} />
            )}
          </div>
          <div>
            <div className="flex flex-col justify-center items-center gap-[20px]">
              <button
                className={classNames(
                  'h-[60px] flex items-center justify-center bg-main gap-[4px] w-[343px] md:w-full border-none rounded-[30px]  text-[#FFFFFF] font-bold',
                  {
                    'opacity-50 hover':
                      !userInfo ||
                      (userInfo?.userInfo && usage && !usage.available) ||
                      !usage ||
                      isPending ||
                      watch('products.0.link') === '',
                  }
                )}
                disabled={
                  !userInfo || userInfo
                    ? (userInfo?.userInfo && usage && !usage.available) ||
                      !usage ||
                      isPending ||
                      watch('products.0.link') === ''
                    : false
                }
              >
                <span>{t('productVideoEditor.buttons.generateVideo')}</span>
              </button>
            </div>
          </div>
        </form>
        <div
          className={classNames('', {
            'flex flex-col w-full  ': !isMobile,
            'flex flex-col w-full': isMobile,
          })}
        >
          <FastclickDescription userInfo={userInfo} />
        </div>

        <div
          className={classNames('', {
            'flex flex-col w-full bg-[#F6F8FB] px-8 py-10 rounded-[40px] gap-8 ':
              !isMobile,
            'flex flex-col w-full bg-[#F6F8FB] px-8 py-10  gap-7': isMobile,
          })}
        >
          <p className="font-bold text-[24px]">
            {t('productVideoEditor.faq.title')}
          </p>
          <div>
            <p className="font-bold text-[20px] ">
              {t('productVideoEditor.faq.extensionRequired.question')}
            </p>
            <p className="text-[#5E6068]">
              {t('productVideoEditor.faq.extensionRequired.answer')}
            </p>
            <p>
              <a
                className="text-error font-bold"
                href="https://www.youtube.com/watch?v=VMJKnYM8rH4"
                target="_blank"
                rel="noreferrer"
              >
                {t('productVideoEditor.faq.extensionRequired.videoGuideLink')}{' '}
              </a>
              <a
                className="font-bold text-[#4360EC]"
                href="https://chromewebstore.google.com/detail/%ED%8C%A8%EC%8A%A4%ED%8A%B8%EC%BB%B7ai/meeeiblldcmbdhhaibnbpdiiknkoaakl?utm_source=item-share-cb"
                target="_blank"
                rel="noreferrer"
              >{t('productVideoEditor.faq.extensionRequired.installLink')}</a>
            </p>
          </div>
          <div>
            <p className="font-bold text-[20px] ">{t('productVideoEditor.faq.generationTime.question')}</p>
            <p className="text-[#5E6068]">
              {t('productVideoEditor.faq.generationTime.answer')}
            </p>
          </div>
          <div>
            <p className="font-bold text-[20px]">
              {t('productVideoEditor.faq.downloadLocation.question')}
            </p>
            <p className="text-[#5E6068]">
              {t('productVideoEditor.faq.downloadLocation.answer')}
            </p>
          </div>
          <div>
            <p className="font-bold text-[20px]">
              {t('productVideoEditor.faq.countingCriteria.question')}
            </p>
            <p className="text-[#5E6068]">
              {t('productVideoEditor.faq.countingCriteria.answer')}
            </p>
          </div>
          <div>
            <p className="font-bold text-[20px]">
              {t('productVideoEditor.faq.dailyUpload.question')}
            </p>
            <p className="text-[#5E6068]">
              {t('productVideoEditor.faq.dailyUpload.answer')}
            </p>
          </div>
        </div>

        <GuideToUse />
        {!isRequest && <Spinner />}
        {essentialCheck && (
          <Modal isModal={essentialCheck}>
            <div className="bg-white w-[335px] min-h-[184px] h-auto p-[20px] border-t rounded-t-[20px]">
              <div className="flex flex-col items-center justify-center h-full gap-[24px]">
                <p className="font-bold text-[18px]">
                  {errorTitle === ''
                    ? '🙌 필수 정보를 입력해주세요!'
                    : errorTitle}
                </p>
                <p className="text-[14px] w-full">{errorText}</p>
                {/* <p className="text-red-500">{errorMessage}</p> */}
              </div>
            </div>
            <div className=" w-[335px] bg-main h-[60px] border-b  border-main rounded-b-[20px] flex justify-center items-center">
              <button
                className="text-white w-[400px] font-bold"
                onClick={() => {
                  setRequest(true)
                  setEssentialCheck(false)
                }}
              >
                확인
              </button>
            </div>
          </Modal>
        )}
        {saveSuccessModal && (
          <Modal isModal={saveSuccessModal}>
            <div className="bg-white md:w-[400px] w-[335px] h-[184px] p-[20px] border-t rounded-t-[40px]">
              <div className="flex flex-col items-center justify-center h-full gap-[24px]">
                <p className="font-bold text-[18px]">요청 완료</p>
                <div>
                  <p className="text-[14px]">
                    {usage?.usedCount && (
                      <span className=" text-main font-bold">
                        총 {Number(usage?.usedCount) + 1}개
                      </span>
                    )}{' '}
                    /{' '}
                    <span className="text-[#8F929B]">
                      {usage?.totalLimit}개
                    </span>
                  </p>
                  <p className="text-[14px] text-main font-bold">
                    영상이 요청되었습니다.
                  </p>
                  <p className="text-[14px">
                    생성 현황은 <span className="font-bold">‘사용 현황'</span>{' '}
                    페이지에서 확인하세요.
                  </p>
                </div>
              </div>
            </div>
            <div className="md:w-[400px] w-[335px] h-[60px]  rounded-b-[40px] flex justify-center items-center">
              <button
                className=" w-[50%] h-full font-bold bg-[#EEF1F7] border border-[#EEF1F7] rounded-bl-[40px]  text-[#5E6068]"
                onClick={() => {
                  setSaveSuccessModal(false)
                  refetch()
                  usageRefetch()
                  navigate('/my-videos')
                }}
              >
                사용 현황 페이지 가기
              </button>
              <button
                className="w-[50%] bg-main border border-main rounded-br-[40px] h-full text-white font-bold"
                onClick={() => {
                  const isTrialUser = userInfo?.userType === UserType.체험
                  const isProUser = userInfo?.userType === UserType.프로
                  const isPremiumUser = userInfo?.userType === UserType.프리미엄
                  const isUsageLimitReached =
                    Number(usage?.usedCount) + 1 === Number(usage?.totalLimit)

                  if (
                    (isProUser || isPremiumUser || isTrialUser) &&
                    isUsageLimitReached
                  ) {
                    setSaveSuccessModal(false)
                    refetch()
                    usageRefetch()
                    navigate('/my-videos')
                  } else {
                    setSaveSuccessModal(false)
                    //window.location.reload()
                    refetch()
                    usageRefetch()

                    handleInitData()
                  }
                }}
              >
                확인
              </button>
            </div>
          </Modal>
        )}

        {isPlanPriceModal && (
          <PlanPriceModal
            isPlanPriceModal={isPlanPriceModal}
            setPlanPriceModal={setPlanPriceModal}
            userInfo={userInfo}
          />
        )}
        {mobileStatus && (
          <Modal isModal={mobileStatus}>
            <div className="bg-white w-[300px] h-[150px] p-[20px] border-t rounded-t-[20px]">
              <div className="flex flex-col items-center justify-center h-full gap-[24px]">
                <p className="font-bold text-[18px]">
                  스마트폰으로 접속하셨습니다.
                </p>
                <div className="flex flex-col leading-[22px]">
                  <p className="text-main font-bold">PC사용을 권장합니다.</p>
                </div>
              </div>
            </div>
            <div className="w-[300px] bg-main h-[40px] border-b border-main  rounded-b-[20px] flex justify-center items-center">
              <button
                className="text-white w-[330px]"
                onClick={() => {
                  setMobileStatus((prev) => !prev)
                }}
              >
                확인
              </button>
            </div>
          </Modal>
        )}
        {isYoutube && (
          <Modal isModal={isYoutube}>
            <div className="bg-white w-[400px] h-[184px] p-[20px] border-t rounded-t-[20px]">
              <div className="flex flex-col items-center justify-center h-full gap-[24px]">
                <p className="font-bold text-[18px]">
                  🚨 필수! 자동 업로드 설정을 해주세요!
                </p>
                <div className="flex flex-col leading-[22px]">
                  <p className="">
                    패스트컷 프로/프리미엄 플랜의 완벽한 사용을 위해
                    <br /> 내 유튜브 채널 현황을 파악하고 <br />
                    자동업로드가 될 수 있도록 설정 해주셔야 합니다 🙏
                  </p>
                </div>
              </div>
            </div>
            <div className="w-[400px] bg-main h-[60px] border-b border-main rounded-b-[20px] flex justify-center items-center">
              <button
                className="text-white w-[330px]"
                onClick={() => {
                  setIsYoutube((prev) => !prev)
                  navigate('/youtube-auth')
                }}
              >
                자동업로드 설정하러 가기
              </button>
            </div>
          </Modal>
        )}

        <ScriptSelector
          watch={watch}
          setValue={setValue}
          control={control}
          translatePlanName={translatePlanName}
          promptGroupList={aiPromptGroup}
          userInfo={userInfo}
          setPromptStatus={setPromptStatus}
          setToneTooltip={setToneTooltip}
          promptStatus={promptStatus}
          toneTooltip={toneTooltip}
        />

        {isOpenExtensionMethod && (
          <ExtensionListModal
            watch={watch}
            userInfo={userInfo}
            setValue={setValue}
            control={control}
            isOpenExtensionMethod={isOpenExtensionMethod}
            setOpenExtensionMethod={setOpenExtensionMethod}
            setIsOpenExtensionListFailModal={setIsOpenExtensionListFailModal}
            selectedLinkIds={selectedLinkIds}
            setSelectedLinkIds={setSelectedLinkIds}
            linkPageSize={linkPageSize}
            setLinkPageSize={setLinkPageSize}
            linkCurrentPage={linkCurrentPage}
            setLinkCurrentPage={setLinkCurrentPage}
            LINK_PAGE_CNT={LINK_PAGE_CNT}
            setSelectedLinks={setSelectedLinks}
            setAiName={setAiName}
            isAiName={isAiName}
            setAiRecommendClipTitle={setAiRecommendClipTitle}
            setAiRecommendThumbnailTitle={setAiRecommendThumbnailTitle}
            mutateAsync={mutateAsync}
            isPending={isPending}
            thumbnailMutateAsync={thumbnailMutateAsync}
            thumbnailIsPending={thumbnailIsPending}
            createVideoType={createVideoType}
          />
        )}
        {isGuideModal && (
          <GuideModal
            isGuideModal={isGuideModal}
            setGuideModal={setGuideModal}
            userInfo={userInfo}
          />
        )}
        {isFailWithShortModal && (
          <FailWithShortModal
            isFailWithShortModal={isFailWithShortModal}
            setFailWithShortModal={setFailWithShortModal}
            handleScroll={handleScroll}
          />
        )}

        {isOpenExtensionListFailModal && (
          <ExtensionListFailModal
            isOpenExtensionListFailModal={isOpenExtensionListFailModal}
            setIsOpenExtensionListFailModal={setIsOpenExtensionListFailModal}
          />
        )}

        <TransitionModal
          isTransitionModal={isTransitionModal}
          setTransitionModal={setTransitionModal}
          handleLoadedMetadata={handleLoadedMetadata}
          handlePlayButtonClick={handlePlayButtonClick}
          handleVideoEnded={handleVideoEnded}
          videoRefs={videoRefs}
          videoPlaying={videoPlaying}
          userInfo={userInfo}
          Controller={Controller}
          watch={watch}
          translatePlanName={translatePlanName}
          control={control}
          setValue={setValue}
          selectedTransitionIndex={selectedTransitionIndex}
          setSelectedTransitionIndex={setSelectedTransitionIndex}
          copyTransitionList={copyTransitionList}
          setCopyTransitionList={setCopyTransitionList}
        />
      </div>
    </>
  )
}
